export const blockIconsHomeNestRemoteComfortSensorNew = (
	<span className='material-symbols-outlined'>nest_remote_comfort_sensor</span>
);
